import DateInputField from "./DateInputField";

function MovimientoForm({ form, onChange, onSubmit, disabled = false }) {
  return (
    <article className="panel">
      <h2>Movimiento de caja</h2>
      <form className="form-grid" onSubmit={onSubmit}>
        <label>
          <span className="visually-hidden">Tipo</span>
          <select name="tipo" value={form.tipo} onChange={onChange} aria-label="Tipo" disabled={disabled}>
            <option value="ingreso">Ingreso</option>
            <option value="egreso">Egreso</option>
          </select>
        </label>
        <label>
          <span className="visually-hidden">Concepto</span>
          <input
            name="concepto"
            value={form.concepto}
            disabled={disabled}
            onChange={onChange}
            placeholder="Concepto"
            aria-label="Concepto"
            required
          />
        </label>
        <label>
          <span className="visually-hidden">Fecha</span>
          <DateInputField
            name="fecha"
            value={form.fecha}
            onChange={onChange}
            ariaLabel="Fecha"
            required
            disabled={disabled}
          />
        </label>
        <label>
          <span className="visually-hidden">Monto</span>
          <input
            type="number"
            min="1"
            step="0.01"
            name="monto"
            value={form.monto}
            disabled={disabled}
            onChange={onChange}
            placeholder="Monto"
            aria-label="Monto"
            required
          />
        </label>
        {disabled ? <p className="status-warn">El día de hoy ya fue cerrado. Solo puedes registrar movimientos en otra fecha abierta.</p> : null}
        <button type="submit" disabled={disabled}>Guardar movimiento</button>
      </form>
    </article>
  );
}


export default MovimientoForm;